import React from "react";
import Typography from "@mui/material/Typography";

const Paragraph = ({ paragraph }) => {
  return (
    <Typography variant="body1" component="div">
      {paragraph}
    </Typography>
  );
};

export default Paragraph;
